/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { appConfig } from '@/AppConfig';
import { User } from '@/generated/graphql';

declare global {
  interface Window {
    intercomSettings: any;
    Intercom: any;
  }
}

export const addUserToIntercom = (user: User) => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('boot', {
      app_id: appConfig.intercom?.appId,
      email: user.username,
      name: user.username
    });
  }
};
